import type { PublishToEventItem } from '@app/routes/content/domain';

import {
  UNIFIED_RECORDINGS_MODEL_EVENT_CREATED_CUTOFF,
  UNIFIED_RECORDINGS_MODEL_EVENT_START_CUTOFF,
} from './constants';

/**
 * Mirrors the PRODUCTION LaunchDarkly date rules for replay-enable-unified-recordings-model
 * https://app.launchdarkly.com/projects/default/flags/replay-enable-unified-recordings-model/targeting?env=production
 */
export const supportsUnifiedRecordingsModel = (event: PublishToEventItem) => {
  const createdAt = new Date(event.createdAt).getTime();
  const timeStart = new Date(event.timeStart).getTime();

  const matchesCreatedAtRule =
    Number.isFinite(createdAt) &&
    createdAt > UNIFIED_RECORDINGS_MODEL_EVENT_CREATED_CUTOFF;

  const matchesTimeStartRule =
    Number.isFinite(timeStart) &&
    timeStart > UNIFIED_RECORDINGS_MODEL_EVENT_START_CUTOFF;

  return matchesCreatedAtRule || matchesTimeStartRule;
};
